import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(e) {
    this.element.submit();
  }
}
